import React, { useState } from "react";
import { useAuth } from "../context/AuthContext";
import ProfileSettings from "../components/settings/ProfileSettings";
import SecuritySettings from "../components/settings/SecuritySettings";
import PrivacySettings from "../components/settings/PrivacySettings";
import NotificationSettings from "../components/settings/NotificationSettings";
import "./SettingsPage.css";

const SettingsPage = () => {
  const { user, updateUser } = useAuth();
  const [activeTab, setActiveTab] = useState("profile");
  const [message, setMessage] = useState({ type: "", text: "" });

  // Render different settings sections based on active tab
  const renderSettingsContent = () => {
    switch (activeTab) {
      case "profile":
        return (
          <ProfileSettings 
            user={user} 
            updateUser={updateUser} 
            setMessage={setMessage} 
          />
        );

      case "security":
        return (
          <SecuritySettings 
            setMessage={setMessage} 
          />
        );
        
      case "privacy":
        return (
          <PrivacySettings 
            setMessage={setMessage} 
          />
        );

      case "notifications":
        return (
          <NotificationSettings 
            setMessage={setMessage} 
          />
        );

      default:
        return (
          <div className="settings-default">
            <p>Select a settings category from the left menu.</p>
          </div>
        );
    }
  };

  return (
    <div className="settings-container">
      {/* New Title Section */}
      <div className="settings-page-title-container">
        <h1 className="settings-page-title">Settings</h1>
        <p className="settings-page-subtitle">
          Customize your account preferences and privacy options
        </p>
      </div>

      {message.text && (
        <div className={`settings-message ${message.type}`}>{message.text}</div>
      )}

      <div className="settings-layout">
        <div className="settings-sidebar">
          <ul className="settings-menu">
            <li className={activeTab === "profile" ? "active" : ""}>
              <button onClick={() => setActiveTab("profile")}>
                <span className="icon profile-icon"></span>
                Profile
              </button>
            </li>
            <li className={activeTab === "security" ? "active" : ""}>
              <button onClick={() => setActiveTab("security")}>
                <span className="icon security-icon"></span>
                Security
              </button>
            </li>
            <li className={activeTab === "privacy" ? "active" : ""}>
              <button onClick={() => setActiveTab("privacy")}>
                <span className="icon privacy-icon"></span>
                Privacy & Data
              </button>
            </li>
            <li className={activeTab === "notifications" ? "active" : ""}>
              <button onClick={() => setActiveTab("notifications")}>
                <span className="icon notifications-icon"></span>
                Notifications
              </button>
            </li>
          </ul>
        </div>

        <div className="settings-content">{renderSettingsContent()}</div>
      </div>
    </div>
  );
};

export default SettingsPage;